module.exports = __webpack_public_path__ + "img/40-2-n.28e583a1.png";